import { RouteObject } from 'react-router-dom';
import { Users } from '../Users';
import { CreateUsers, EditUser } from '../pages';
import ViewUser from '../pages/ViewUser/ViewUser';

const UsersRoutes: RouteObject[] = [
  {
    path: 'users',
    element: <Users />,
  },
  {
    path: 'users/create',
    element: <CreateUsers />,
  },
  {
    path: 'users/:userId',
    element: <ViewUser />,
  },
  {
    path: 'users/:userId/edit',
    element: <EditUser />,
  },
];

export default UsersRoutes;
